// environment.dev.ts (dev API)
export const environment = {
  production: false,
  apiUrl: 'https://dev.trackingapi.riyashuma.co.za/api',
  sessionTimeoutMinutes: 30
};
